export const getEnabledSystemModules = (options?: { [key: string]: string }) => {
    const res: { [key: string]: boolean } = {
        task: !options || !options.module_task || options.module_task != 'disabled',
        chat: !options || !options.module_chat || options.module_chat != 'disabled',
        calendar: !options || !options.module_calendar || options.module_calendar != 'disabled',
        video: !options || !options.module_video || options.module_video != 'disabled',
        report: !options || !options.module_report || options.module_report != 'disabled',
        wiki: !options || !options.module_wiki || options.module_wiki != 'disabled',
    };
    return res;
}
